export const tabs = [
  {
    id: 1,
    label: "Wax",
  },
  {
    id: 2,
    label: "Dip",
  },
  {
    id: 3,
    label: "Dewax",
  },
  {
    id: 4,
    label: "Foundry",
  },
  {
    id: 5,
    label: "Post Foundry",
  },
  {
    id: 6,
    label: "Outside Processing",
  },
  {
    id: 7,
    label: "Inspection",
  },
];

const isNotN = (value) => value === null || isNaN(value);

export const handleNewLayout = ({ tables, setLayout }) => {
  const newLayout = tables?.map((table, index) => {
    const { x, y, w, h } = table;

    const useDefault = [x, y, w, h].every((i) => isNotN(i));

    const l = useDefault
      ? {
          x: index % 2 ? 2 : 0,
          y: Math.floor(index / 2),
          w: tables?.length > 1 ? 2 : 4,
          h: tables?.length > 1 ? 1 : 4,
        }
      : { x, y, w, h };

    return {
      i: table?.id?.toString(),
      ...l,
    };
  });

  setLayout(newLayout);
};

const padding = 15;

export const updateGridSize = (gridRef, setDimensions) => () => {
  const handleGridSize = () => {
    if (gridRef.current) {
      const parent = gridRef.current;
      const height = (parent?.offsetHeight - padding * 3) / 2;
      const width = parent?.offsetWidth - padding;

      setDimensions({ height, width });
    }
  };

  handleGridSize();

  window.addEventListener("resize", handleGridSize);

  return () => window.removeEventListener("resize", handleGridSize);
};
